import http from "../../helpers/http";

import {
  FETCH_POLICY_AND_LEGISLATION_CONTENT_SUCCESS,
  FETCH_POLICY_AND_LEGISLATION_CONTENT_FAILED
} from "../actions/actionTypes";

export const fetchData = () => (dispatch) => {
  http
    .get("policy-and-legislation")
    .then(({ data }) => {
      dispatch({
        type: FETCH_POLICY_AND_LEGISLATION_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_POLICY_AND_LEGISLATION_CONTENT_FAILED,
        payload: error
      });
    });
};
